// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607300233/js/" + chunkId + "." + {"44":"30ee9078","225":"852852f1","481":"b2f322f4","486":"d9cfefac","770":"e2172d9d"}[chunkId] + ".0.612310324981213.chunk.js";
};